import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to the top of the viewport whenever the route pathname changes.
 * Mounted once globally so every CTA / nav / link returns the user to the
 * top of the new page (instead of preserving the previous scroll position).
 *
 * Skipped when the new URL contains a #hash anchor (let the browser handle it).
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // Use auto (instant) so the new page renders at the top without a visible jump.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);

  return null;
}
